import { call, put, select, takeEvery } from 'redux-saga/effects'

import { BOOK_TYPE, ebookKeys } from 'app/constants/ebook.constants'
import { isEmpty } from 'app/utils/array'

import { getEbooks } from 'app/services/api/data.service'
import {
  BIBLIOTECA_ACTIONS,
  CAMINOS_ACTIONS,
  CAMINOS_3_CA_ACTIONS,
  EBOOKS_ACTIONS,
  TEXAS_ELAR_2E_ACTIONS,
  TEXAS_ELAR_ACTIONS,
  TEXAS_SLAR_2E_ACTIONS,
  TEXAS_SLAR_ACTIONS,
  bibliotecaActionCreators,
  caminos3CAActionCreators,
  caminosActionCreators,
  ebooksActionCreators,
  texasElar2EActionCreators,
  texasElarActionCreators,
  texasSlar2EActionCreators,
  texasSlarActionCreators,
} from 'app/store/actions/media/ebooks.actions'
import { ReduxSagaAction } from 'app/types/store.types'

const actions = {
  [BOOK_TYPE.LIBRARY]: ebooksActionCreators,
  [BOOK_TYPE.LIBRARY3]: ebooksActionCreators,
  [BOOK_TYPE.BIBLIOTECA]: bibliotecaActionCreators,
  [BOOK_TYPE.CAMINOS_BIBLIOTECA]: caminosActionCreators,
  [BOOK_TYPE.CAMINOS_3_BIBLIOTECA]: caminosActionCreators,
  [BOOK_TYPE.CAMINOS_3_CA_BIBLIOTECA]: caminos3CAActionCreators,
  [BOOK_TYPE.TEXAS_ELAR]: texasElarActionCreators,
  [BOOK_TYPE.TEXAS_SLAR]: texasSlarActionCreators,
  [BOOK_TYPE.TEXAS_ELAR_2E]: texasElar2EActionCreators,
  [BOOK_TYPE.TEXAS_SLAR_2E]: texasSlar2EActionCreators,
}

function* getEbooksSaga({
  payload: bookCategory,
}: ReduxSagaAction<keyof typeof ebookKeys>): Generator {
  let action
  try {
    const ebookKey = ebookKeys[bookCategory] || ebookKeys.LIBRARY
    action = actions[bookCategory] || actions.LIBRARY

    let data = yield select((state) => state.ebooks[ebookKey].data)

    if (isEmpty(data)) {
      const contentToken = yield select((state) => state.userData.contentToken)
      data = yield call(getEbooks, bookCategory, contentToken as string)
    }

    yield put(action.success({ data }))
  } catch (error) {
    if (action) {
      yield put(action.failure({ error }))
    }
  }
}

export default function* watchEbooksActions() {
  yield takeEvery(
    [
      EBOOKS_ACTIONS.REQUEST,
      BIBLIOTECA_ACTIONS.REQUEST,
      CAMINOS_ACTIONS.REQUEST,
      CAMINOS_3_CA_ACTIONS.REQUEST,
      TEXAS_SLAR_ACTIONS.REQUEST,
      TEXAS_ELAR_ACTIONS.REQUEST,
      TEXAS_ELAR_2E_ACTIONS.REQUEST,
      TEXAS_SLAR_2E_ACTIONS.REQUEST,
    ],
    getEbooksSaga
  )
}
